// extracted by mini-css-extract-plugin
export default {"postReport":"PostReport_postReport__-h4MJ","contentTitle":"PostReport_contentTitle__2cJKr","content":"PostReport_content__j4ZpG","backButton":"PostReport_backButton__hOsfO"};